export const PUNCHOUT_PO_PENDING = 'PO Pending';
